import script from './SdsSidebarItem.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"sds-sidebar-item sds-focus",class:{ 'is-active': _vm.isActive },on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"sds-sidebar-item__content"},[(_vm.iconName)?_c('SdsIcon',{attrs:{"iconName":_vm.iconName,"isThemed":_vm.isIconThemed,"size":"md"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sds-sidebar-item__label capitalize"},[_vm._v(_vm._s(_vm.label))])],1),_vm._v(" "),(_vm.badge)?_c('SdsBadge',{attrs:{"background":"elevation","variant":_vm.isActive ? 'primary' : 'secondary',"styling":_vm.isActive ?  'brand' : 'ghost',"size":"md"}},[_vm._v("\n        "+_vm._s(_vm.badge)+"\n    ")]):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-cb703508_0", { source: ".sds-sidebar-item[data-v-cb703508]{display:flex;justify-content:space-between;align-items:center;padding:8px 12px;min-height:40px;background-color:transparent;border:none;border-radius:var(--radius-full);font-family:var(--system-label-default-family),sans-serif;font-size:var(--system-label-default-size);font-weight:600;line-height:var(--system-label-default-line-height);letter-spacing:var(--system-label-default-letter-spacing);color:var(--system-text-on-elevation-secondary);cursor:pointer}.sds-sidebar-item__content[data-v-cb703508]{display:flex;align-items:center;gap:8px}.sds-sidebar-item__label[data-v-cb703508]{text-align:start}.sds-sidebar-item.is-active[data-v-cb703508]{color:var(--system-text-on-elevation-brand-primary);background:var(--gradients-component-sidebar-active)}.sds-sidebar-item.is-active[data-v-cb703508]:hover{background:var(--gradients-component-sidebar-active-hover)}.sds-sidebar-item[data-v-cb703508]:hover:not(.is-active){background:var(--gradients-component-sidebar-inactive-hover)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-cb703508";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
